import React from 'react'

function TenderCircularOpticlean() {
  return (
    <embed src="\pdfs\EAT1.1.10.2_OC-R_Circular_Opticlean_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderCircularOpticlean